import TaxonomyTerm from "../../types/TaxonomyTerm";
import { TaxonomyAction, TaxonomyState } from "./TaxonomyState";

export const DISPATCH = 'WIS/taxonomy/game_involvement/DISPATCHED';
export const FULFILL = 'WIS/taxonomy/game_involvement/FULFILLED';
export const REJECT = 'WIS/taxonomy/game_involvement/REJECTED';

export type GameInvolvementActionTypes = 
  'WIS/taxonomy/game_involvement/DISPATCHED'
  | 'WIS/taxonomy/game_involvement/FULFILLED'
  | 'WIS/taxonomy/game_involvement/REJECTED';

export const dispatch = () => ({ type: DISPATCH });
export const fulfill = (payload: TaxonomyTerm[]) => ({ type: FULFILL, payload });
export const reject = (error: string) => ({ type: REJECT, error });


const initialState: TaxonomyState = {
  terms: [],
  isFetching: false,
  isFetched: false,
  error: null,
};

export type TaxonomyGameInvolvementAction = TaxonomyAction<GameInvolvementActionTypes>;

export default function reducer(state = initialState, action: TaxonomyGameInvolvementAction) {
  switch (action.type) {
    case DISPATCH:
      return {
        ...state,
        isFetching: true,
      };

    case FULFILL:
      return {
        ...state,
        terms: action.payload,
        isFetching: false,
        isFetched: true,
        error: null,
      };

    case REJECT:
      return {
        ...state,
        error: action.error,
        isFetching: false,
      };

    default:
      return state;
  }
}
